import {SurveyElementConditionType, SurveyValueType} from 'core/SurveyModels'

export class SurveyConditionComparatorService {
  evaluate(
    type: SurveyElementConditionType,
    value: string | number,
    target: SurveyValueType
  ) {
    switch (type) {
      case 'contains':
        return SurveyConditionComparatorService.contains(value, target)
      case 'equalTo':
        return SurveyConditionComparatorService.equal(value, target)
      case 'notEqual':
        return SurveyConditionComparatorService.notEqual(value, target)
      case 'notContains':
        return SurveyConditionComparatorService.notContains(value, target)
      case 'anyOf':
        return SurveyConditionComparatorService.anyOf(value, target)
      case 'empty':
        return SurveyConditionComparatorService.empty(value, target)
      case 'notEmpty':
        return SurveyConditionComparatorService.notEmpty(value, target)
    }
  }

  private static equal(value: string | number, target: SurveyValueType) {
    if (Array.isArray(target)) {
      const chunks: string[] = value.toString().split(',')
      return (
        chunks.length === target.length &&
        chunks.every((ch) => (target as string[]).includes(ch))
      )
    }
    return value.toString() === target?.toString()
  }

  private static contains(value: SurveyValueType, target: SurveyValueType) {
    if (Array.isArray(target)) {
      return (value as unknown[])?.every((v: unknown) =>
        (target as unknown[]).includes(v)
      )
    }
    return target?.toString().includes((value ?? '').toString())
  }

  private static notEqual(value: string | number, target: SurveyValueType) {
    return !SurveyConditionComparatorService.equal(value, target)
  }

  private static notContains(value: string | number, target: SurveyValueType) {
    return !SurveyConditionComparatorService.contains(value, target)
  }

  private static anyOf(value: SurveyValueType, target: SurveyValueType) {
    if (Array.isArray(target)) {
      return (value as unknown[])?.some((v: unknown) =>
        (target as unknown[]).includes(v)
      )
    }
    return target?.toString().includes((value ?? '').toString())
  }

  private static empty(_: string | number, target: SurveyValueType) {
    if (Array.isArray(target)) {
      return !target || target.length === 0
    }
    return !target
  }

  private static notEmpty(value: string | number, target: SurveyValueType) {
    return !SurveyConditionComparatorService.empty(value, target)
  }
}
